import {Modal} from "bootstrap";
import Cookies from "js-cookie"

//Check user is already on the mailing list, don't show it
if(Cookies.get("mailing") !== "true"){


    //Check daily popup limit
    if(!Cookies.get("mailing-popup")){
        var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);

        window.addEventListener('load', (event) => {
            initModal()
            Cookies.set("mailing-popup", "true", {
                expires: 1
                //expires: inFifteenMinutes
            })
        })

    }
}

function initModal(){

    let res = document.getElementById('#mailListPopUp');
    if(!res) return

    const mailModal = new Modal('#mailListPopUp');
    mailModal.show();

    setTimeout(()=>{

        $("#mailing-subscribe-form-2").on("submit", function(e){
            e.preventDefault();
    
            if(!$(this).valid()){
                if(typeof Ladda !== "undefined") Ladda.stopAll();
                return
            }
    
            const formData = $(this).serialize();
            $.post("/services/constant-contact/add-email.php", formData, function(data){
                console.log("FIRE")
                Swal.fire(
                    "Thank you for subscribing",
                    "Get 20% off your next order with discount code 20PERCENT",
                    "success"
                )
    
                if(typeof Ladda !== "undefined") Ladda.stopAll();      
                Cookies.set("mailing", "true")      
            });
    
        })

    }, 100)

}